// extracted by mini-css-extract-plugin
export default {"element":"powerelem_element__JORsW","image":"powerelem_image__Z8P+F","text":"powerelem_text__aoFDl"};